import React, { useContext } from 'react'

import { ModalBusyContext } from './modalContext'

interface ModalFooterProps {
  children?: React.ReactNode
  className?: string
  testId?: string
}

/** Fixed action row of a `Modal` that uses slots; it never scrolls out of view. */
const ModalFooter: React.FC<ModalFooterProps> = ({ children, className = '', testId }) => {
  const busy = useContext(ModalBusyContext)

  return (
    <div
      className={`shrink-0 border-t border-crypto-border p-4 sm:p-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end ${className}`}
      aria-busy={busy ? true : undefined}
      data-testid={testId}
    >
      {children}
    </div>
  )
}

export default ModalFooter
